<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'DRUG_GROUP.DRUG_GROUPS_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddDrugGroup">
          <button
            (click)="createDrugGroup()"
            mat-raised-button
            matTooltip="Create new drug group"
            color="primary"
            type="button"
          >
            <span class="svg-icon-md" translate="DRUG_GROUP.NEW_DRUG_GROUP">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Drug Group
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 145px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Drug Groups
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG_GROUP.TABLE.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drugGroup">
            <span
              [matTooltip]="canViewDrugGroup(drugGroup) ? 'View Drug Group' : null"
              [class.clickable]="canViewDrugGroup(drugGroup)"
              (click)="viewDrugGroupDblclick(drugGroup.id, drugGroup)"
              >{{ drugGroup.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG_GROUP.TABLE.NAME' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'DRUG_GROUP.TABLE.NAME' | translate"
                [(ngModel)]="searchNameInput"
              />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'DRUG.TABLE.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let drugGroup">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(drugGroup.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(drugGroup.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DRUG_GROUP.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'DRUG_GROUP.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let drugGroup">
            <ng-template ngxPermissionsOnly="canViewDrugGroup">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Drug Group"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewDrugGroup(drugGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditDrugGroup">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Drug Group"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editDrugGroup(drugGroup.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateDrugGroup">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Drug Group"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForDrugGroup(drugGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteDrugGroup">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Drug Group"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteDrugGroup(drugGroup)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>

